import { useState } from "react";
import Fileponds from "../../../../components/filepond/Filepond";
import useUploadMaterial from "../hooks/useUploadMaterial";
import Input from "../../../../components/input/Input";
import Button from "@/components/Button";
import { Spinner } from "@nextui-org/react";
import { useParams } from "react-router-dom";

function CreateMaterial({ onCloseModal }) {
    const { lectureId, courseId } = useParams();
    const [material, setMaterial] = useState();
    const [name, setName] = useState("");
    const [brief, setBrief] = useState("");

    const { uploadMaterial, isUploading, error } = useUploadMaterial();

    function onSubmit() {
        if (name && material?.[0]?.serverId && brief) {
            uploadMaterial(
                {
                    lectureId,
                    courseId,
                    name,
                    brief,
                    file: material[0]?.serverId,
                },
                {
                    onSuccess: () => {
                        setBrief("");
                        setName("");
                        setMaterial("");
                        onCloseModal?.();
                    },
                }
            );
        }
    }

    return (
        <div className="flex flex-col justify-center gap-5 w-full md:w-[600px] pt-5">
            <Input
                label="الأسم"
                size="fullWidth"
                type="text"
                name="name"
                disabled={isUploading}
                error={error?.response?.data?.errors?.name?.[0]}
                value={name}
                onChange={(e) => setName(e.target.value)}
            />

            <Input
                label="الوصف"
                type="text"
                name="brief"
                disabled={isUploading}
                error={error?.response?.data?.errors?.brief?.[0]}
                size="fullWidth"
                value={brief}
                onChange={(e) => setBrief(e.target.value)}
            />

            <p>رفع الملف:</p>
            <Fileponds filePath="images/questions/" imageToken={setMaterial} />
            <div className="w-full py-3">
                <Button
                    type="primary"
                    className="flex items-center justify-center w-full leading-8"
                    disabled={isUploading}
                    onClick={onSubmit}
                >
                    {isUploading ? <Spinner color="white" /> : "إضافة ملف"}
                </Button>
            </div>
        </div>
    );
}

export default CreateMaterial;
